import VerificationQueue from './components/Cards/VerificationQueue.vue'

/**
 * Register company-module Nova Vue components
 *
 * @param {import('vue').App} app
 */
const companyModuleSetup = (app) => {
  app.component('verification-queue', VerificationQueue)
}

export { companyModuleSetup }
